export const SEARCH = "Search Flights";
export const MISSING_INFO_SEARCH_ERROR =
  "To continue, please complete all required fields.";
